import ax from './interceptor'

let prefixUrl = '';

/**
 * 普通post
 * @param url
 * @param params
 * @returns {Promise<any>}
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    ax({
      url: prefixUrl + url,
      method: 'post',
      params: params
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * post, 参数在requestBody中
 * @param url
 * @param params
 * @returns {Promise<any>}
 */
export function postBody(url, params) {
  return new Promise((resolve, reject) => {
    ax({
      url: prefixUrl + url,
      method: 'post',
      data: params
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}


/**
 * post混合请求
 * @param url
 * @param bodyParam
 * @param params
 * @returns {Promise<unknown>}
 */
export function postMix(url, bodyParam, params) {
  return new Promise((resolve, reject) => {
    ax({
      url: prefixUrl + url,
      method: 'post',
      data: bodyParam,
      params: params
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * get请求
 * @param url
 * @param params
 * @returns {Promise<any>}
 */
export function get(url, params) {
  if (params) {
    for (let i in params) {
      let item = params[i];
      if (item == null) {
        delete params[i];
      }
    }
  }

  return new Promise((resolve, reject) => {
    ax({
      url: prefixUrl + url,
      method: 'get',
      params: params
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getParam(url, params) {
  return new Promise((resolve, reject) => {
    ax({
      url: prefixUrl + url + params,
      method: 'get',
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export function filePost(url, params) {
  return new Promise((resolve, reject) => {
    ax({
      url: prefixUrl + url,
      method: 'post',
      data: params,
      headers: {
        "Content-Type": "multipart/form-data"
      },
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}
